import toCamelCase from 'to-camel-case';
import toSnakeCase from 'to-snake-case';

export { toCamelCase, toSnakeCase };

export const containsDigits = (string: string) => /\d/.test(string);

export const formatDistance = (distance: Optional<number>) => {
  if (typeof distance === 'number') {
    const miles = distance.toFixed(1);
    return `${miles} miles`;
  }
  return null;
};

export const formatPhone = (value: Optional<string>) => {
  if (value) {
    const v = String(value).replace(/\D/g, '');
    const patterns = [
      {
        format: '+{1} ({2}) {3}-{4}',
        pattern: /^(1)(\d{3})(\d{3})(\d{4})$/,
      },
      {
        format: '({1}) {2}-{3}',
        pattern: /^(\d{3})(\d{3})(\d{4})$/,
      },
      {
        format: '{1} {2} {3}',
        pattern: /^(\d{3})(\d{4})(\d{4})$/,
      },
    ];
    let formatted: string | null = null;
    patterns.forEach(({ pattern, format }) => {
      if (!formatted) {
        const m = v.match(pattern);
        if (m) {
          let formatted0 = format;
          m.forEach((match, i) => {
            formatted0 = formatted0.replace(`{${i}}`, match);
          });
          formatted = formatted0;
        }
      }
    });
    return formatted ?? v;
  }
  return null;
};

export const incrementNumberInString = (input: string) => {
  const match = input.match(/\d+/);
  if (match) {
    const number = parseInt(match[0], 10) + 1;
    return input.replace(/\d+/, number.toString());
  }
  return input;
};

export const padLeft = (str: string, padStr: string, len: number): string => {
  if (len > str.length) {
    return padLeft(`${padStr}${str}`, padStr, len);
  }
  return str;
};

export const titleCase = (str: string) => str.toLowerCase().split(' ').map(word => (word.charAt(0).toUpperCase() + word.slice(1))).join(' ');

export const toTitleCase = (str: string) => {
  if (!str) {
    return '';
  }

  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const snakeCaseToTitleCase = (str: string) => (
  str
    .replace(/^[-_]*(.)/, (_, c: string) => c.toUpperCase()) // Initial char (after -/_)
    .replace(/[-_]+(.)/g, (_, c: string) => ` ${c.toUpperCase()}`) // First char after each -/_
);

export const toFirstUpperCase = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const toUnderscore = (str: string) => str?.split('::').map(part => toSnakeCase(part)).join('/');

// UTF-16 index just past the first `num` code points. The boundary never lands inside a
// surrogate pair, so slicing there can't split an emoji into a lone (JSON-breaking) surrogate.
const codePointBoundary = (str: string, num: number): number => {
  let boundary = 0;
  let count = 0;
  for (const char of str) {
    if (count >= num) {
      break;
    }
    boundary += char.length;
    count += 1;
  }
  return boundary;
};

export const firstCodePoints = (str: string, num: number): string => str.slice(0, codePointBoundary(str, num));

export const trimString = (string: string, maxLength: number) => (
  (codePointBoundary(string, maxLength) < string.length) ?
    `${firstCodePoints(string, maxLength - 3)}...` :
    string
);

export const truncateString = (str: string, num: number) => {
  const boundary = codePointBoundary(str, num);
  if (boundary >= str.length) {
    return str;
  }
  return `${str.slice(0, boundary)}...`;
};

export const camelCaseToKebabCase = (str: string): string => str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
